/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md8 lg8>
        <range-date-picker :from="dateFrom" :to="dateTo" :span='false' @change:from="changeFrom"
          @change:to="changeTo" @change:date="onChangeHandler($event)" :fullPicker="true" @error:rangePick="pickerErrorHandler">
        </range-date-picker>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4>
        <v-select :items="intervals" v-model="interval" :label="$t('Select Interval')" item-text="text"
          item-value="value" outline></v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg2 md3 sm4 xs6>
        <v-select :items="firstItemList" v-model="firstSelection" :label="$t('Select Device')" outline>
        </v-select>
      </v-flex>
      <v-flex lg2 md3 sm4 xs6>
        <v-select v-if="showSecond" :items="secondItemList" v-model="secondSeleciton"
          :label="label2" item-text="text" item-value="modifiedId" outline multiple>
          <template slot="prepend-item">
            <v-list-tile ripple @click="toggleSecond">
              <v-list-tile-action>
                <!-- <v-icon >{{ icon }}</v-icon> -->
                <v-icon color="indigo darken-4">{{icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-if="secondSeleciton.length == 0">{{ $t('Select All') }}</v-list-tile-title>
                <v-list-tile-title v-else-if="secondSeleciton.length == secondItemList.length">
                  {{ $t('Deselect All') }}
                </v-list-tile-title>
                <v-list-tile-title v-else>{{ $t('Select All') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template slot="selection" slot-scope="{ item, index }">
            <span v-if="index === 0">
              {{ item.text }}
            </span>
            <span v-if="index === 1" class="grey--text caption">(+{{ secondSeleciton.length - 1 }}
              {{ $t('others') }})</span>
          </template>
        </v-select>
      </v-flex>
      <v-flex lg2 md3 sm4 xs6>
        <v-select v-if="showThird" :items="thirdItemList" v-model="thirdSelection" :label="label3"
          item-text="text" item-value="modifiedId" outline multiple>
          <template slot="prepend-item">
            <v-list-tile ripple @click="toggleThird">
              <v-list-tile-action>
                <v-icon :color="thirdItemList.length > 0 ? 'indigo darken-4' : ''">{{ icon }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-if="thirdSelection.length == 0">{{ $t('Select All') }}</v-list-tile-title>
                <v-list-tile-title v-else-if="thirdSelection.length == thirdItemList.length">
                  {{ $('Deselect All') }}
                </v-list-tile-title>
                <v-list-tile-title v-else>{{ $t('Select All') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template slot="selection" slot-scope="{ item, index }">
            <span v-if="index === 0">
              {{ item.text }}
            </span>
            <span v-if="index === 1" class="grey--text caption">(+{{ thirdSelection.length - 1 }}
              {{ $t('others') }})</span>
          </template>
        </v-select>
      </v-flex>
      <v-flex lg2 md3 sm4 xs6>
        <v-select v-if="showFourth" :items="fourthItemList" v-model="fourthSeleciton"
          :label="label4" item-text="text" item-value="modifiedId" outline multiple>
          <template slot="prepend-item">
            <v-list-tile ripple @click="toggleFourth">
              <v-list-tile-action>
                <v-icon :color="fourthItemList.length > 0 ? 'indigo darken-4' : ''">{{ icon }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-if="fourthSeleciton.length == 0">{{ $t('Select All') }}</v-list-tile-title>
                <v-list-tile-title v-else-if="fourthSeleciton.length == fourthItemList.length">
                  {{ $t('Deselect All') }}
                </v-list-tile-title>
                <v-list-tile-title v-else>{{ $t('Select All') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template slot="selection" slot-scope="{ item, index }">
            <span v-if="index === 0">
              {{ item.text }}
            </span>
            <span v-if="index === 1" class="grey--text caption">(+{{ fourthSeleciton.length - 1 }}
              {{ $t('others') }})</span>
          </template>
        </v-select>
      </v-flex>
      <v-flex lg2 md3 sm4 xs6>
        <v-select v-if="showFifth" :items="fifthItemList" v-model="fifthSeleciton" :label="label5"
          item-text="text" item-value="modifiedId" outline multiple>
          <template slot="prepend-item">
            <v-list-tile ripple @click="toggleFifth">
              <v-list-tile-action>
                <v-icon :color="fifthItemList.length > 0 ? 'indigo darken-4' : ''">{{ icon }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-if="fifthSeleciton.length == 0">{{ $t('Select All') }}</v-list-tile-title>
                <v-list-tile-title v-else-if="fifthSeleciton.length == fifthItemList.length">
                  {{ $t('Deselect All') }}
                </v-list-tile-title>
                <v-list-tile-title v-else>{{ $t('Select All') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template slot="selection" slot-scope="{ item, index }">
            <span v-if="index === 0">
              {{ item.text }}
            </span>
            <span v-if="index === 1" class="grey--text caption">(+{{ fifthSeleciton.length - 1 }}
              {{ $t('others') }})</span>
          </template>
        </v-select>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>

    <v-layout align-center justify-center mt-1>
      <v-btn color="success" @click="getData($event, true ,false)" large :disabled="isEnabled">
        {{ $t('Download') }}</v-btn>
      <v-btn color="success" @click="getData($event, false ,true)" large :disabled="isViewEnabled">
        {{ $t('View') }}</v-btn>
    </v-layout>
  </div>
</template>

<script>
import CommonApi from '@/services/Common'
import ReportApi from '@/services/Report'
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'
import {
  EventBus
} from '@/services/event-bus'

const moment = require('moment')

export default {
  data: () => ({
    isDateValid: true,
    interval: null,
    firstItemList: [],
    secondItemList: [],
    thirdItemList: [],
    fourthItemList: [],
    fifthItemList: [],
    firstSelection: '',
    secondSeleciton: '',
    thirdSelection: '',
    fourthSeleciton: '',
    fifthSeleciton: '',
    isDisabled: false,
    showSecond: false,
    showThird: false,
    showFourth: false,
    showFifth: false,
    // Button Loading
    loader: null,
    downloadLoading: false,
    tableLoading: false,
    // Calendar Component
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    plantName: ''
  }),
  components: {
    'range-date-picker': require('@/components/utility/RangeDatePicker').default
  },
  async mounted() {
    let response = await CommonApi.getDeviceList(this.getSelectedPlantId)

    this.firstItemList = response.data.message
    this.plantName = this.getActivePlantInfo('plant_name') + '-Report'
  },
  computed: {
    ...mapGetters([
      'getSelectedPlantId',
      'getUserInfo',
      'getActivePlantInfo'
    ]),
    icon() {
      return 'mdi-checkbox-blank-outline'
    },
    isEnabled() {
      return !(this.isDisabled && this.interval && this.isDateValid)
    },
    isViewEnabled() {
      const from = moment(this.dateFrom, 'YYYY-MM-DD')
      const to = moment(this.dateTo, 'YYYY-MM-DD')
      const days = Math.abs(to.diff(from, 'day')) + 1

      const totalDataCount = (days * this.deviceSelections * parseInt(1400 / this.interval))

      return !(totalDataCount > 0 && totalDataCount <= 2800 && this.isDateValid)
    },
    deviceSelections() {
      if (this.isDisabled) {
        if (this.showFifth) {
          return this.fifthSeleciton.length
        }
        if (this.showFourth) {
          return this.fourthSeleciton.length
        }
        if (this.showThird) {
          return this.thirdSelection.length
        }
        if (this.showSecond) {
          return this.secondSeleciton.length
        }
      }
      return 0
    },
    selectAllSecond() {
      return this.secondSeleciton.length === this.secondItemList.length
    },
    selectAllThird() {
      return this.thirdSelection.length === this.thirdItemList.length
    },
    selectAllFourth() {
      return this.fourthSeleciton.length === this.fourthItemList.length
    },
    selectAllFifth() {
      return this.fifthSeleciton.length === this.fifthItemList.length
    },
    label2() {
      if (this.firstSelection == 'Energy Meter') { return `${this.$t('Select')} EM` } else return this.$t('Select Block')
    },

    label3() {
      if (this.firstSelection == 'Soil Sensor') { return `${this.$t('Select')} Soil Sensor` } else if (this.firstSelection == 'Weather Station') { return `${this.$t('Select')} WS` } else if (this.firstSelection == 'Annunciator') { return `${this.$t('Select')} Annunciator` } else if (this.firstSelection == 'MFM') { return `${this.$t('Select')} MFM` } else if (this.firstSelection == 'Transformer') { return `${this.$t('Select')} Transformer` } else if (this.firstSelection == 'Relay') { return `${this.$t('Select')} Relay` } else if (this.firstSelection == 'Breaker') { return `${this.$t('Select')} Breaker` } else return this.$t('Select INV ROOM')
    },

    label4() {
      if (this.firstSelection == 'Ups') { return `${this.$t('Select')} UPS` } else if (this.firstSelection == 'Transformer') { return `${this.$t('Select')} Transformer` } else return `${this.$t('Select')} Inverter`
    },

    label5() {
      if (this.firstSelection == 'SCB') { return `${this.$t('Select')} SCB` }
      if (this.firstSelection == 'ZMU') { return `${this.$t('Select')} ZMU` } else return `${this.$t('Select')} Inverter`
    },
    intervals() {
      if (this.getUserInfo('role') === 'customer') {
        return [{
          text: '15 Min',
          value: 15
        }]
      } else {
        return [{
          text: '1 Day',
          value: 24
        },
        {
          text: 'Hour',
          value: 60
        },
        {
          text: '30 Min',
          value: 30
        },
        {
          text: '15 Min',
          value: 15
        },
        {
          text: '10 Min',
          value: 10
        },
        {
          text: '5 Min',
          value: 5
        },
        {
          text: '1 Min',
          value: 1
        }
        ]
      }
    }
  },
  methods: {
    ...mapMutations('settings', ['ADD_DOWNLOAD_LIST', 'SET_DOWNLOAD_LIST']),
    ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT', 'SET_PROGRESS_BAR']),
    toggleSecond() {
      this.$nextTick(() => {
        if (this.selectAllSecond) {
          this.secondSeleciton = []
        } else {
          this.secondSeleciton = this.secondItemList.map(item => item.modifiedId)
        }
      })
    },
    toggleThird() {
      this.$nextTick(() => {
        if (this.selectAllThird) {
          this.thirdSelection = []
        } else {
          this.thirdSelection = this.thirdItemList.map(item => item.modifiedId)
        }
      })
    },
    toggleFourth() {
      this.$nextTick(() => {
        if (this.selectAllFourth) {
          this.fourthSeleciton = []
        } else {
          this.fourthSeleciton = this.fourthItemList.map(item => item.modifiedId)
        }
      })
    },
    toggleFifth() {
      this.$nextTick(() => {
        if (this.selectAllFifth) {
          this.fifthSeleciton = []
        } else {
          this.fifthSeleciton = this.fifthItemList.map(item => item.modifiedId)
        }
      })
    },
    onChangeHandler(value, filter) {
      this.isDateValid = true
      this.dateFrom = value.from
      this.dateTo = value.to
    },
    updateSnackbar(payload) {
      this.isDateValid = false
      this.SET_SHOW_SNACKBAR(true)
      this.SET_SNACKBAR_CONTENT(payload)
    },
    pickerErrorHandler() {
      this.updateSnackbar({
        icon: 'error',
        message: 'Selected date exceeds 30 day'
      })
    },
    getData: async function (event, showDownload = false, emit = false) {
      const id = Math.random().toString()
      let dateTime = moment(this.dateTo).diff(moment(this.dateFrom), 'days')
      console.log(dateTime, this.dateTo, this.dateFrom, 'DIFFERENCE IN NUMBER OF DAYS')
      let param = this.verifyParam()
      if (param) {
        if (showDownload && dateTime <= 30 && dateTime >= 0) {
          this.ADD_DOWNLOAD_LIST({
            id,
            title: 'downloaded',
            plantId: this.getSelectedPlantId,
            device: this.firstSelection,
            downloading: true,
            status: 'unknown',
            blockId: '1'
          })
        }
        if (emit) {
          this.SET_PROGRESS_BAR(true)
          const response = await ReportApi.getReport(param)
          if (response.data.message.length > 0) {
            EventBus.$emit('reportData', response.data.message)
            this.SET_PROGRESS_BAR(false)
          } else {
            this.SET_PROGRESS_BAR(false)
            this.updateSnackbar({
              icon: 'error',
              message: 'No Data for Specific Date\'s'
            })
          }
        } else {
          const reportName = this.getActivePlantInfo('plant_name') + '-' + param.device
          const encryptedParam = btoa(JSON.stringify(param))
          try {
            await ReportApi.getReportOpt(encryptedParam, reportName)
            if (showDownload) {
              this.SET_DOWNLOAD_LIST({
                id,
                status: 'success'
              })
            }
          } catch (e) {
            if (showDownload) {
              this.SET_DOWNLOAD_LIST({
                id,
                status: 'fail'
              })
            }
          }
        }
      }
    },
    isCollidingWithRange(arr) {
      // if (this.dateFrom !== this.dateTo && arr.length > 1) {
      //   this.showSnackBar('Please Select only one device for date range')
      //   return false
      // }
      return true
    },
    verifyParam: function () {
      let dateDiff = moment(this.dateTo).diff(moment(this.dateFrom), 'days')
      if(dateDiff > 15 && this.interval > 1) {
        this.updateSnackbar({
          icon: 'error',
          message: 'Cannot download data more than 15 days'
        })
        return false
      } if(dateDiff >= 31 && this.interval == 1) {
        this.updateSnackbar({
          icon: 'error',
          message: 'Cannot download data more than a month'
        })
        return false
      } if(this.interval == 1 && moment().diff(moment(this.dateFrom), 'days') > 180) {
        this.updateSnackbar({
          icon: 'error',
          message: 'Cannot Download data beyond 180 days'
        })
        return false
      }
      if (this.interval === null) {
        this.updateSnackbar({
          icon: 'error',
          message: 'Please Select an interval'
        })
        return false
      }
      switch (this.firstSelection.toLowerCase()) {
        case 'energy meter':
          if (this.secondSeleciton !== '') {
            if (this.isCollidingWithRange(this.secondSeleciton)) { return this.getParameter(this.secondSeleciton, this.secondItemList) }
            return false
          } else {
            this.updateSnackbar({
              icon: 'error',
              message: 'Please Select valid parameters'
            })
            return false
          }
        case 'weather station':
        case 'mfm':
        case 'breaker':
        case 'soil sensor':
        case 'annunciator':
        case 'transformer':
        case 'relay':
          if (this.secondSeleciton !== '' && this.thirdSelection !== '') {
            if (this.isCollidingWithRange(this.thirdSelection)) { return this.getParameter(this.thirdSelection, this.thirdItemList) }
            return false
          } else {
            this.updateSnackbar({
              icon: 'error',
              message: 'Please Select valid parameters'
            })
            return false
          }
        case 'inverter':
        case 'ups':
        case 'mppt':
          if (this.secondSeleciton !== '' && this.thirdSelection !== '' && this.fourthSeleciton !== '') {
            if (this.isCollidingWithRange(this.fourthSeleciton)) {
              return this.getParameter(this.fourthSeleciton, this.fourthItemList)
            }
            return false
          } else {
            this.updateSnackbar({
              icon: 'error',
              message: 'Please Select valid parameters'
            })
            return false
          }
        case 'scb':
        case 'zmu':
          if (this.secondSeleciton !== '' && this.thirdSelection !== '' && this.fourthSeleciton !== '' && this.fifthSeleciton !== '') {
            if (this.isCollidingWithRange(this.fifthSeleciton)) { return this.getParameter(this.fifthSeleciton, this.fifthItemList) }
            return false
          } else {
            this.updateSnackbar({
              icon: 'error',
              message: 'Please Select valid parameters'
            })
            return false
          }
        default:
          this.updateSnackbar({
            icon: 'error',
            message: 'Please Select a Device'
          })
          return false
      }
    },
    getParameter(idList, idNamesMap) {
      const deviceNamesMap = {}

      idList
        .forEach(id => {
          deviceNamesMap[id] = idNamesMap.find(d => d.modifiedId == id)['name']
        })

      return {
        plantId: this.getSelectedPlantId,
        idList,
        interval: this.interval,
        deviceNamesMap,
        role: this.getUserInfo('role'),
        module: 'report',
        device: this.firstSelection,
        dateTo: this.dateTo,
        dateFrom: this.dateFrom
      }
    },
    changeFrom(from) {
      this.dateFrom = from
    },
    changeTo(to) {
      this.dateTo = to
    }
  },
  watch: {
    // Handles device selection
    firstSelection: async function () {
      EventBus.$emit('selectionChanged')
      if (this.firstSelection !== '') {
        let response
        if (this.firstSelection.toLowerCase() === 'energy meter') { response = await CommonApi.getIdList(this.getSelectedPlantId, this.firstSelection.toLowerCase(), 1, null) } else { response = await CommonApi.getIdList(this.getSelectedPlantId, this.firstSelection.toLowerCase(), 1, null) }

        this.secondItemList = response.data.message
        this.showSecond = true
        this.showThird = false
        this.showFourth = false
        this.showFifth = false
        this.secondSeleciton = ''
        this.thirdSelection = ''
        this.fourthSeleciton = ''
        this.fifthSeleciton = ''
      } else {
        this.showSecond = false
        this.showThird = false
        this.showFourth = false
        this.showFifth = false
      }
    },
    // Handles Block Seleciton
    secondSeleciton: async function () {
      EventBus.$emit('selectionChanged')
      // if (this.secondSeleciton !== '') {
      if (this.secondSeleciton.length > 0) {
        // let response = await CommonApi.getWsOrInvRoomList(this.getSelectedPlantId, this.firstSelection, this.secondSeleciton);
        this.thirdSelection = ''
        this.fourthSeleciton = ''
        this.fifthSeleciton = ''
        this.showFifth = false
        if (this.firstSelection.toLowerCase() === 'energy meter') {
          console.log('Energy Meter')
          this.isDisabled = true
        } else {
          let response = await CommonApi.getIdList(this.getSelectedPlantId, this.firstSelection, 2, this.secondSeleciton)
          this.thirdItemList = response.data.message
          this.isDisabled = false
          this.showThird = true
          this.showFourth = false
          this.showFifth = false
          this.thirdSelection = ''
          this.fourthSeleciton = ''
          this.fifthSeleciton = ''
        }
      } else {
        this.isDisabled = false
        this.showThird = false
        this.showFourth = false
        this.showFifth = false
      }
    },
    // Handles Ws or inverter room selection
    thirdSelection: async function () {
      EventBus.$emit('selectionChanged')
      // if (this.thirdSelection !== '') {
      if (this.thirdSelection.length > 0) {
        this.fourthSeleciton = ''
        this.fifthSeleciton = ''
        this.showFifth = false
        if (this.firstSelection.toLowerCase() === 'weather station') {
          this.isDisabled = true
          console.log('Weather Station')
        } else if (this.firstSelection.toLowerCase() === 'soil sensor') {
          this.isDisabled = true
          console.log('Soil Selection')
        } else if (this.firstSelection.toLowerCase() === 'annunciator') {
          this.isDisabled = true
          console.log('Annunciator Selection')
        } else if (this.firstSelection.toLowerCase() === 'mfm') {
          this.isDisabled = true
          console.log('MFM Selection')
        } else if (this.firstSelection.toLowerCase() === 'transformer') {
          this.isDisabled = true
          console.log('transformer Selection')
        } else if (this.firstSelection.toLowerCase() == 'relay') {
          this.isDisabled = true
          console.log('relay')
        } else if (this.firstSelection.toLowerCase() == 'breaker') {
          this.isDisabled = true
          console.log('breaker')
        } else {
          // let response = await CommonApi.getInverterList(this.getSelectedPlantId, this.firstSelection, this.secondSeleciton, this.thirdSelection);
          let response = await CommonApi.getIdList(this.getSelectedPlantId, this.firstSelection, 3, this.thirdSelection)
          this.fourthItemList = response.data.message
          this.isDisabled = false
          this.showFourth = true
        }
      } else {
        this.isDisabled = false
        this.showFourth = false
        this.showFifth = false
      }
    },
    fourthSeleciton: async function () {
      EventBus.$emit('selectionChanged')
      // if (this.fourthSeleciton !== '') {
      if (this.fourthSeleciton.length > 0) {
        this.fifthSeleciton = ''
        if (this.firstSelection.toLowerCase() === 'inverter') {
          this.isDisabled = true
        } else if (this.firstSelection.toLowerCase() === 'mppt') {
          this.isDisabled = true
        } else if (this.firstSelection.toLowerCase() === 'scb' || this.firstSelection.toLowerCase() === 'zmu') {
          // let response = await CommonApi.getScbList(this.getSelectedPlantId, this.firstSelection, this.secondSeleciton, this.thirdSelection, this.fourthSeleciton);
          let response = await CommonApi.getIdList(this.getSelectedPlantId, this.firstSelection, 4, this.fourthSeleciton)
          this.fifthItemList = response.data.message
          this.showFifth = true
        } else if (this.firstSelection.toLowerCase() == 'ups') {
          this.isDisabled = true
          console.log('relay')
        }
      } else {
        this.isDisabled = false
        this.showFifth = false
      }
    },
    fifthSeleciton: async function () {
      EventBus.$emit('selectionChanged')
      if (this.fifthSeleciton.length > 0) {
        //   this.fifthSeleciton = ''
        if (this.firstSelection.toLowerCase() === 'scb' || this.firstSelection.toLowerCase() === 'zmu') {
          this.isDisabled = true
        }
      } else {
        this.isDisabled = false
      }
    },
    getSelectedPlantId: async function () {
      this.plantName = this.getActivePlantInfo('plant_name') + '-Report'
      let response = await CommonApi.getDeviceList(this.getSelectedPlantId)
      this.firstItemList = response.data.message
      this.firstSelection = ''
      this.showSecond = false
      this.showThird = false
      this.showFourth = false
      this.showFifth = false
      this.secondSeleciton = ''
      this.thirdSelection = ''
      this.fourthSeleciton = ''
      this.fifthSeleciton = ''
    },
    interval: async function () {
      EventBus.$emit('changeInterval')
    }
  }
}
</script>

<style>
.button {
  background-color: #4CAF50;
  border: none;
  color: white;
  padding-top: 10px;
  padding-right: 32px;
  padding-bottom: 16px;
  padding-left: 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  cursor: pointer;
  height: 44px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  will-change: box-shadow;
  border-radius: 2px;
}
</style>
